export const getCookie = cookieName => {
  const name = cookieName + '=',
    cookies = document.cookie.split(';')

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i]
    while (cookie.charAt(0) === ' ') cookie = cookie.substring(1) // deal with the empty space at the start of cookie
    if (cookie.indexOf(name) === 0)
      return cookie.substring(name.length, cookie.length)
  }
  return ''
}

export const setCookie = (name, value, opts) => {
  let cookieStr = name + '=' + value,
    options = {
      expiryDays: 365,
      path: '/',
    }

  options = { ...options, ...opts }

  if (options.expiryDays !== 0) {
    const date = new Date()

    date.setDate(date.getDate() + options.expiryDays)
    cookieStr += '; expires=' + date.toUTCString()
  }

  if (location.protocol == 'https:') {
    cookieStr += ';secure'
  }

  document.cookie = cookieStr + '; path=' + options.path
}

export const deleteCookie = (name, pathValue) => {
  if (pathValue) setCookie(name, '', { expiryDays: -1, path: pathValue })
  else setCookie(name, '', { expiryDays: -1 })
}
